import httpCommon from "../http-common";

/** Unauthenticated: tenant branding. Pass { host } and/or { subdomain } (see backend). */
const getBranding = (params) =>
  httpCommon.get("/public/institutions/branding", { params });

const publicInstitutionService = {
  getBranding,
};

export default publicInstitutionService;
